import axios from 'axios'
import { baseUrl } from './config'

export function getOldLotteries (params) {
  return axios.get(`${baseUrl}/lotteries/old`, {
    params
  })
}

export function getLottery (params, id) {
  return axios.get(`${baseUrl}/lotteries/${id}`, {
    params
  })
}

export function deleteLottery (id) {
  return axios.delete(`${baseUrl}/lotteries/${id}`)
}
